<template>
  <div class="page-container">
    <div class="nav-container">
      <div v-for="tab in tabs" :key="tab.name" class="nav-item" :class="{ active: activeTabName === tab.name }"
        @click="handleTabClick(tab.name)">
        {{ tab.label }}
      </div>
    </div>
    <component :is="currentComponent" class="component-container"></component>
  </div>
</template>

<script setup>
import { ref, computed } from "vue"
// tabs对应的组件
import heatAnalysis from './heatAnalysis/index.vue'; // 热管理分析
import pack from './pack/index.vue'; // Pack电芯温度变化趋势
import batteryChip from './batteryChip/index.vue'; // 电芯温度变化趋势
import { useAppStore } from "@/store/modules/app";
const appStore = useAppStore()
const $str = window.$str;
const activeTabName = ref('a'); // 被激活的tab页对应的名称

const tabs = computed(() => [
  { name: 'a', label: $str.getKey('数据分析/热管理分析') },
  ...(appStore.hasEb100C ? [] : [
    { name: 'b', label: $str.getKey('数据分析/Pack 电芯温度变化趋势') },
    { name: 'd', label: $str.getKey('数据分析/电芯温度变化趋势') },
  ]),
])

const COMPONENTS = {
  a: heatAnalysis,
  b: pack,
  d: batteryChip,
}

/** 计算动态组件当前渲染的组件 */
const currentComponent = computed(() => {
  return COMPONENTS[activeTabName.value];
})

function handleTabClick(name) {
  activeTabName.value = name
}

</script>
<style lang="scss" scoped>
.page-container {
  font-family: 'HarmonyOS Sans SC', sans-serif;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;

  .nav-container {
    padding: 0 14px;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 1);
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .nav-item {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 20px;
    height: 44px;
    font-family: 'HarmonyOS Sans SC', sans-serif;
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
    line-height: 100%;
    letter-spacing: 0%;
    color: rgba(46, 46, 46, 0.6);
    cursor: pointer;
    white-space: nowrap;
    transition: all 0.3s ease;
    border-radius: 20px;
    background: transparent;
    box-sizing: border-box;

    &:hover {
      color: rgba(46, 46, 46, 0.8);
      background: rgba(0, 0, 0, 0.02);
    }

    &.active {
      color: rgba(58, 104, 255, 1);
      font-weight: 400;
      background: rgba(226, 233, 255, 1);

      &::after {
        display: none;
      }
    }
  }

  .component-container {
    flex: 1;
    min-height: 0;
  }
}
</style>
